import { useState } from "react";
import "./PvtOfficersLogin.css";
import axios from "../../axios.jsx";
import Cookies from "js-cookie";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

function PvtOfficersLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");

  const handleSignInSubmit = async () => {
    var reqData = {
      username: username,
      password: password,
    };
    try {
      const resData = await axios.post("/api/pvtOfficer-login-b", reqData);
      if (resData.status === 200) {
        Cookies.set("userInfo",resData.data.userInfo);
        Cookies.set("username",resData.data.username);
        let cookie_value=Cookies.get('username');
        if(cookie_value==="PaymentOfficer")
        window.location.href = "/pending-payment-list";
        else if(cookie_value==="PlagiarismOfficer")
        window.location.href = "/pending-plagiarism-list";
        else if(cookie_value=="VerifyOfficer")
        window.location.href = "/pending-verification-list";
      }
    } catch (e) {
      setLoginError("Invalid Mobile Number or Password");
    }
  };

  return (
    <>
      <div className="Auth-form-container">
        <form className="Auth-form">
          <div className="Auth-form-content">
            <h3 className="Auth-form-title">Officer Sign In</h3>
            <div className="form-group mt-3">
              <label>Username</label>
              <input
                type="tel"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="form-control mt-1"
                placeholder="Enter Username"
              />
            </div>
            <div className="form-group mt-3">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-control mt-1"
                placeholder="Enter password"
              />
            </div>
            <div className="d-grid gap-2 mt-3">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleSignInSubmit}
              >
                Submit
              </button>
            </div>
            <span className="text-danger justify-content-center">{loginError}</span>
          </div>
        </form>
      </div>
    </>
  )
}

export default PvtOfficersLogin;